import { forwardRef } from 'react';

import { ButtonProps } from '.';
import { StyledButton } from './Button.styled';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref) => {
  return (
    <StyledButton
      {...props}
      disableFocusRipple={true}
      disableRipple={true}
      disableTouchRipple={true}
      ref={ref}
    />
  );
});
Button.displayName = 'Button';
